import classNames from "classnames";
import React from "react";
import { capitalize } from "lodash";
import "./EntityLogo.scss";
import { Tooltip, SkeletonLoader } from "@SeemplicityDev/shared";
interface EntityLogoProps {
  logo?: string | null;
  name?: string;
  iconClassName?: string;
  className?: string;
  isInList?: boolean;
  isLoading?: boolean;
  onClick?: ((e: React.MouseEvent<HTMLSpanElement>) => void) | null;
  url?: string;
  hasBorder?: boolean;
  testid?: string;
  "data-testid"?: string;
  tooltip?: string;
  label?: string;
  showLabel?: boolean;
  isFilterAction?: boolean;
  noEllipsis?: boolean;
  size?: "s" | "m" | "l";
  isCompact?: boolean;
  isSquare?: boolean;
}
const EntityLogo: React.FC<EntityLogoProps> = ({
  logo,
  name,
  iconClassName,
  className,
  isInList,
  isLoading,
  onClick,
  url,
  hasBorder = false,
  "data-testid": dataTestId,
  tooltip,
  label = "",
  showLabel = false,
  isFilterAction = false,
  noEllipsis = false,
  size = "m",
  isCompact = false,
  isSquare = false,
}) => {
  const isClickable = !!onClick || !!url;
  const shouldDisplayLabel = showLabel && (name || label);
  const content = (
    <Tooltip
      type={tooltip ? "info" : "ellipsis"}
      content={!noEllipsis ? tooltip || (name ? capitalize(name) : "") : ""}
    >
      <div
        className={classNames("entity-logo-container", {
          "with-label": shouldDisplayLabel,
        })}
      >
        <div
          className={classNames("entity-logo", className, {
            "is-loading": isLoading,
            "is-in-list": isInList,
            "has-border": hasBorder,
            "is-clickable": isClickable,
            "is-filter-action": isFilterAction,
            [`size-${size.toLowerCase()}`]: size,
            "is-compact": isCompact,
            "is-square": isSquare,
            "no-ellipsis": noEllipsis,
          })}
        >
          {!isLoading && (iconClassName || logo) ? (
            iconClassName ? (
              <i className={`seem-icon ${iconClassName}`} />
            ) : (
              <>
                <img
                  data-testid={dataTestId || `${name}-logo`}
                  className="logo"
                  src={logo ?? undefined}
                  alt={name}
                  loading="lazy"
                />
                {!isFilterAction && isClickable && (
                  <i className="seem-icon seem-icon-external-link" />
                )}
              </>
            )
          ) : (
            <SkeletonLoader width={"16px"} height={"16px"} />
          )}
        </div>
        {shouldDisplayLabel &&
          (isLoading ? (
            <SkeletonLoader width={"80px"} height={"16px"} />
          ) : (
            <span className="entity-name">{label || name}</span>
          ))}
      </div>
    </Tooltip>
  );
  if (!!url) {
    return (
      <a
        href={url}
        rel="noopener noreferrer"
        target="_blank"
        onClick={(e) => e.stopPropagation()}
      >
        {content}
      </a>
    );
  } else {
    return <span onClick={(e) => onClick?.(e)}>{content}</span>;
  }
};
export default EntityLogo;
